import { DataGrid } from '@mui/x-data-grid'
import React from 'react'
import { Button, Grid,} from "@mui/material";


function CustomDataGridTable({rows, columns, showTable, loading, message, ...dataGridAttr}) {
    // console.log("table component",showTable, loading, rows)
  return (
    <>
        {showTable && (!loading &&
            rows.length <= 0 ? 
                <p>{message}</p> 
                : <>
                    <DataGrid 
                        rows={rows}
                        columns={columns}
                        {...dataGridAttr}
                        // initialState={{
                        // pagination: {
                        //     paginationModel: { page: 0, pageSize: 10 },
                        // },
                        // }}
                        // checkboxSelection
                        // selectionModel={selectionModel}
                        // onRowSelectionModelChange={handleSelectionModelChange}
                        // options={{
                        //     sorting: true
                        // }}
                        // pageSizeOptions={[10, 20]}
                    />
                </>
            )
        }
    </>
  )
}

export default CustomDataGridTable